<template>
  <a-card id="warehouse-and-inventory">
    <h4 class="mb-4">
      {{ $t('product.inventory') }}
    </h4>
    
    <a-form-model-item prop="inventories" class="mb-0">
      <div class="table-base mb-4">
        <div class="scroll-box">
          <table class="table table-hover inventory-table">
            <thead>
              <tr>
                <th rowspan="2">
                  {{ $t('product.warehouse') }}
                </th>
                <th rowspan="2">
                  SKU
                </th>
                <th v-if="items.length > 1" rowspan="2">
                  {{ $t('pageTitles.name') || $t('auth.name') }}
                </th>
                <th colspan="2" class="text-center" style="width: 190px">
                  {{ $t('product.stock') }}
                </th>
                <th rowspan="2" class="text-center" style="width: 65px">
                  {{ $t('product.unit') }}
                </th>
                <th rowspan="2" class="text-center" style="width: 75px">
                  {{ $t('product.preorder') }}
                </th>
                <th rowspan="2" class="text-center" style="width: 70px">
                  {{ $t('product.main_warehouse') }}
                </th>
                <th rowspan="2" class="text-center" style="width: 60px">
                  #
                </th>
              </tr>
              <tr>
                <th class="text-center" style="width: 95px">
                  {{ $t('product.availability') }}
                </th>
                <th class="text-center" style="width: 95px">
                  {{ $t('product.on_hand') }}
                </th>
              </tr>
            </thead>
            <tbody>
              <template v-if="isNoData">
                <tr>
                  <td :colspan="items.length > 1 ? 9 : 8" class="text-center">
                    {{ $t('dashboardContent.no_data') }}
                  </td>
                </tr>
              </template>
              <template v-else>
                <template v-for="(inventory, index) in inventories">
                  <template>
                    <tr v-for="(catalog, idx) in items" :key="`${inventory.id}.${idx}`">
                      <td v-if="idx == 0" :rowspan="items.length || 1">
                        {{ inventory.name }}
                      </td>
                      <td>{{ catalog.sku || '-' }}</td>
                      <td v-if="items.length > 1">
                        {{ catalog.title || '-' }}
                      </td>
                      <td class="text-center">
                        {{ catalog.availability || 0 }}
                      </td>
                      <td class="text-center">
                        {{ catalog.on_hand || 0 }}
                      </td>
                      <td class="text-center">
                        {{ catalog.price.uom || '-' }}
                      </td>
                      <td class="text-center">
                        <a-switch size="small" :disabled="isLoading" @change="onChangePreOrder($event, index, idx)" />
                      </td>
                      <td v-if="idx == 0" :rowspan="items.length || 1" class="text-center">
                        <a-radio
                          :checked="inventory.is_main"
                          :value="inventory.id"
                          :disabled="isLoading"
                          @change="onChangeMainWarehouse(index)"
                        />
                      </td>
                      <td v-if="idx == 0" :rowspan="items.length || 1" class="text-center">
                        <a-popconfirm
                          :title="$t('product.confirm_remove_warehouse')"
                          @confirm="removeWarehouse(index)"
                        >
                          <a-button
                            v-if="!isLoading"
                            type="link"
                            icon="delete"
                            class="text-danger"
                          >
                            <a-icon type="trash" />
                          </a-button>
                        </a-popconfirm>
                      </td>
                    </tr>
                  </template>
                </template>
              </template>
            </tbody>
          </table>
        </div>
      </div>

      <a-button
        type="primary"
        icon="plus"
        ghost
        :disabled="isLoading"
        @click="onOpenAddWarehouseModal"
      >
        {{ $t('product.add_warehouse') }}
      </a-button>
    </a-form-model-item>

    <a-modal
      :visible="isWarehouseModalVisible"
      :title="$t('product.add_warehouse_location')"
      :closable="false"
      :footer="null"
      centered
    >
      <a-form-model ref="formWarehouse" :model="frm" :rules="rulesWarehouse">
        <a-form-model-item prop="warehouse">
          <a-select
            v-model="frm.warehouse"
            size="large"
            class="select-antd-default"
            :placeholder="$t('product.search_select_warehouse')"
            allow-clear
            show-search
            :filter-option="filterOption"
          >
            <a-select-option
              v-for="warehouse in warehouseList"
              :key="warehouse.warehouse_id"
              :value="warehouse.warehouse_id"
            >
              {{ warehouse.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-row :gutter="16">
          <a-col :span="12">
            <a-button
              type="primary"
              size="large"
              ghost
              block
              @click="isWarehouseModalVisible = false"
            >
              {{ $t('fulfillment.cancel') || $t('common.cancel') }}
            </a-button>
          </a-col>
          <a-col :span="12">
            <a-button
              type="primary"
              size="large"
              block
              @click="addWarehouse"
            >
              {{ $t('product.apply') }}
            </a-button>
          </a-col>
        </a-row>
      </a-form-model>
    </a-modal>
  </a-card>
</template>

<script>

const DEFAULT_ITEM_LIST = [
  {
    "id": 1,
    "factory_sku": null,
    "images": [],
    "option": null,
    "price": {
        "currency": "IDR",
        "value": 0,
        "min_qty": 1,
        "price_qty": 1,
        "uom": "PCS",
        "id": null,
        "formula_id": null,
        "product_variables": [],
    },
    "sku": null,
    "barcode": null,
    "status": true,
    "title": null,
    "loading": false,
    "msg": "",
    "availability": 0,
    "on_hand": 0,
    "sku_exist": 0,
  },
]
export default {
  name: 'WarehouseAndInventories',
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    catalogs: {
      type: Array,
      default: () => [],
    },
    warehouses: {
      type: Array,
      default: () => [],
    },
    defaultItem: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      isWarehouseModalVisible: false,
      defaultInventory: {
        id: 1,
        uom: 'PCS',
        pre_order_status: false,
        sellable: 0,
        allocated: 0,
        on_hand: 0,
      },
      frm: { warehouse: '' },
      rulesWarehouse: {
        warehouse: [{ required: true, message: this.$t('product.validate_warehouse_required'), trigger: 'change' }],
      },
    }
  },
  computed: {
    inventories: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      },
    },
    isLoading() {
      return this.loading
    },
    items() {
      if (this.catalogs.length === 0) {
        return DEFAULT_ITEM_LIST
      }
      return this.catalogs
    },
    warehouseList() {
      return this.warehouses.filter(warehouse => {
        const findWarehouseIndex = this.inventories.findIndex(inventory => inventory.id === warehouse.warehouse_id)
        return findWarehouseIndex < 0
      })
    },
    isNoData() {
      return !this.inventories.length || !this.items.length
    },
  },
  watch: {
    items(newValue) {
      this.inventories = this.inventories.map(inventory => ({
        ...inventory,
        catalogs: this.setCatalogs(newValue),
      }))
    },
  },
  methods: {
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().includes(input?.toLowerCase())
      )
    },
    onOpenAddWarehouseModal() {
      if (this.$refs.formWarehouse) {
        this.$refs.formWarehouse.resetFields()
      }

      this.frm.warehouse = ''
      this.isWarehouseModalVisible = true
    },
    addWarehouse() {
      this.$refs.formWarehouse.validate(valid => {
        if (valid) {
          this.isWarehouseModalVisible = false
          const findMainWarehouse = this.inventories.find(warehouse => warehouse.is_main)
          this.inventories.push({
            id: this.frm.warehouse,
            name: this.getWarehouseName(this.frm.warehouse),
            is_main: findMainWarehouse?.id ? false : true,
            catalogs: this.setCatalogs(this.items),
          })
          this.$emit('validate', 'inventories')
        }
      })
    },
    removeWarehouse(index) {
      if (this.inventories.length > 1 && this.inventories[index].is_main) {
        const newIndex = this.inventories?.[index - 1]?.id
          ? index - 1
          : index + 1
        this.inventories[newIndex].is_main = true
      }

      this.inventories.splice(index, 1)
    },
    onChangeMainWarehouse(index) {
      const prevMainWarehouseIndex = this.inventories.findIndex(warehouse => warehouse.is_main)
      if (prevMainWarehouseIndex > -1) {
        this.inventories[prevMainWarehouseIndex].is_main = false
      }

      this.inventories[index].is_main = true
    },
    onChangePreOrder(value, inventoryIndex, catalogIndex) {
      this.inventories[inventoryIndex].catalogs[catalogIndex].pre_order_status = value
    },
    getWarehouseName(warehouse_id) {
      const findWarehouse = this.warehouseList.find(warehouse => warehouse.warehouse_id === warehouse_id)
      return findWarehouse?.name || '-'
    },
    setCatalogs(items) {
      const defaultInventory = JSON.parse(JSON.stringify(this.defaultInventory))
      return items.map(item => ({
          ...defaultInventory,
          id: item.id,
          uom: item.price.uom,
        }))
    },
  },
}
</script>

<style lang="scss">
.table-base {
  position: relative;
}

.scroll-box {
  position: relative;
  width: 100%;
  max-height: 500px;
  overflow-y: scroll;
}

.inventory-table {
  border-collapse: separate;
  border-spacing: 0;
  table-layout: fixed;

  thead {
    position: sticky;
    top: 0;
    z-index: 2;
  }

  tbody {
    max-height: 100px;
    overflow-y: auto;
  }

  th {
    background: #f0f2f4;
  }

  th, td {
    position: relative;
    padding: 6px;
    vertical-align: middle !important;
    border: 0.5px solid #dee2e6;
    line-height: normal;
  }
}
</style>